import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-devis',
  templateUrl: './document-devis.component.html',
  styleUrls: ['./document-devis.component.scss']
})
export class DocumentDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
